import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03dfa9fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body py-3 p-8" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3" }
const _hoisted_4 = { class: "fw-bolder text-muted" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-gray-400" }, "ID", -1))
const _hoisted_6 = { class: "min-w-140px text-gray-400" }
const _hoisted_7 = { class: "min-w-120px text-gray-400" }
const _hoisted_8 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px text-gray-400" }, "STATUS", -1))
const _hoisted_10 = { class: "badge badge-light fw-normal me-auto" }
const _hoisted_11 = {
  to: "#",
  class: "text-dark fw-normal text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "symbol symbol-35px symbol-circle" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 1,
  class: "bg-light-success text-success symbol-label fw-bold"
}
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "svg-icon svg-icon-3 d-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("ticketsTable.name")), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("ticketsTable.dueDate")), 1),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(_ctx.$t("ticketsTable.members")), 1))
                : _createCommentVNode("", true),
              _hoisted_9
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketList, (ticket, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(ticket.ticketID), 1)
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_router_link, {
                    to: {
                      name: 'ticketDetails',
                      params: { ticketKey: ticket.ticketID },
                    },
                    class: "text-dark fw-normal text-hover-primary d-block mb-1 fs-6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(ticket.description), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(ticket.date), 1)
                ]),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (!!ticket.user.avatar)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: ticket.user.avatar,
                              alt: ticket.user.name,
                              class: "rounded-circle"
                            }, null, 8, _hoisted_14))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(ticket.user.name.charAt(0).toUpperCase()), 1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass([`badge-light-${ticket.status.color}`, "badge"])
                  }, _toDisplayString(ticket.status.label), 3)
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    to: {
                      name: 'ticketDetails',
                      params: { ticketKey: ticket.ticketID },
                    },
                    class: "btn btn-sm btn-light me-2",
                    id: "kt_user_follow_button"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_component_inline_svg, { src: "svg/icons/arr012.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("ticketsTable.view")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}